export const DISTRIBUTION_STATES = {
  TIMEPOINT_CLOSED: "timepoint_closed",
  TIMEPOINT_PAUSED: "timepoint_paused",
  TIMEPOINT_RECRUITMENT_CLOSED: "timepoint_recruitment_closed",
  INACTIVE: "inactive",
  NOT_STARTED: "not_started",
  ENDED: "ended",
  INVALID_TOKEN: "invalid_token",
  NOT_ELIGIBLE: "not_eligible",
  ALREADY_COMPLETED: "already_completed",
  PARTICIPANT_NOT_FOUND: "participant_not_found",
  PARTICIPANT_REQUIRED: "participant_required",
  MISSING_PARTICIPANT_TIMEPOINT: "missing_participant_timepoint",
  TEAM_SUBSCRIPTION_INACTIVE: "team_subscription_inactive",
};

export const DISTRIBUTION_STATE_VALUES = new Set(
  Object.values(DISTRIBUTION_STATES),
);

export const isDistributionState = (state) =>
  DISTRIBUTION_STATE_VALUES.has(state);
